import FidelityProgram from './FidelityProgram.view';

export default FidelityProgram;
